<template>
  <div class="container-fuild m-0 p-0">
    <headerLayout />
    <!-- header Layout -->
    <main>
      <div class="bg_gray">
        <div class="container margin_detail">
          <div class="row mb-3" v-if="orderObj.orderStatus==2 && orderObj.cancellation_enable">
            <div class="col-md-8 align-right">
              <button :disabled="orderCancel"
                  class="btn_1 view_details"
                  style="
                        color: #000 !important;
                        background: #ffc60c !important;
                      "
              @click="cancelOrder(orderObj.oid)">
                Cancel Order
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 list_menu">
              <div id="reviews">
                <div class="review_card">
                  <div class="row">
                    <div class="col-md-6 review_content">
                      <div class="clearfix">
                        <h3 v-if="isCafeteria === 0" class="cardTitle">
                          Delivery Address
                        </h3>
                        <h3 v-if="isCafeteria === 1" class="cardTitle">
                          Hello {{ userName }}
                        </h3>
                        <p
                          class="orderStatus"
                          style="color: #f3766a !important"
                        >
                          Your Order is {{ orderStatus }}
                        </p>
                      </div>

                      <!-- Order type Pick up -->
                      <div class="orderInfo" v-if="orderTypeByEnum == 1">
                        <p>
                          Please show your
                          <a class="customAnch">Order #{{ orderInfo }}</a> at
                          the counter, to pickup your order.
                        </p>
                        <span style="color: #777777"
                          >Pick your order from,</span
                        >
                        <div
                          class="strip"
                          style="margin-top: 9px"
                          v-if="restaurantDetails != ''"
                        >
                          <a
                            class="menu_item restaurantCard"
                            style="background: #fef1f0"
                          >
                            <figure>
                              <img
                                :src="
                                  restaurantDetails.restaurantImage == null ||
                                  restaurantDetails.restaurantImage == ''
                                    ? 'img'
                                    : restaurantDetails.restaurantImage
                                "
                                onerror="this.src='https://assets.cloudkitch.co.in/user_documents/Placeholder.png';"
                                width="90"
                                data-src="img/menu-thumb-1.jpg"
                                alt="thumb"
                                class="lazy"
                              />
                            </figure>
                            <div>
                              <h3 style="font-size: 17px">
                                {{ restaurantDetails.restaurantName }} -
                                {{ restaurantDetails.restaurantBranchName }}
                              </h3>
                              <span style="font-size: 14px; color: #777">{{
                                restaurantDetails.restaurantAddress
                              }}</span>
                            </div>
                          </a>
                        </div>
                        <!-- pickup from div -->

                        <div
                          class="paymentTypeFromData"
                          style="margin-bottom: 12px"
                        >
                          <div class="row">
                            <div class="col-4">
                              <img
                                src="../../templateAssests/img/ckgallery/packaging.png"
                                alt="thumb"
                                width="70"
                                height="70"
                              />
                            </div>
                            <div class="col-8 align-right">
                              <p>Pickup</p>
                              <p>Pickup order, {{ pickUpon }}</p>
                            </div>
                          </div>
                        </div>

                        <!-- Payment type div -->
                        <div class="paymentTypeFromData">
                          <div class="row">
                            <div class="col-4">Payment Type</div>
                            <div
                              class="col-8 align-right"
                              style="font-family: 'GothamMedium' !important"
                            >
                              {{ PaymentType }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- / Order type Pick up -->

                      <!--  Order type Delivery  -->
                      <div class="orderInfo" v-if="orderTypeByEnum == 2">
                        <div
                          class="strip"
                          style="margin-top: 9px"
                          v-if="restaurantDetails != ''"
                        >
                          <a
                            class="menu_item deliverCard restaurantCard"
                            style="background: #fef1f0; min-height: 100px"
                          >
                            <figure>
                              <img
                                :src="
                                  restaurantDetails.restaurantImage == null ||
                                  restaurantDetails.restaurantImage == ''
                                    ? 'img'
                                    : restaurantDetails.restaurantImage
                                "
                                onerror="this.src='https://assets.cloudkitch.co.in/user_documents/Placeholder.png';"
                                width="90"
                                data-src="img/menu-thumb-1.jpg"
                                alt="thumb"
                                class="lazy"
                              />
                            </figure>
                            <div class="deliveryCardDiv">
                              <h3 class="deliverH3" style="font-size: 17px">
                                {{ restaurantDetails.restaurantName }}
                              </h3>
                              <span style="font-size: 14px; color: #777">{{
                                restaurantDetails.restaurantBranchName
                              }}</span>
                            </div>
                          </a>
                        </div>
                        <!-- delivery from div -->
                        <div class="deliverToCard">
                          <span style="color: #777777">Deliver to,</span>
                          <div
                            class="deliverToCardDiv"
                            style="margin-bottom: 12px"
                          >
                            <div class="row" v-if="orderObj != ''">
                              <div class="col-md-12 col-lg-12 col-xl-12">
                                <p class="addressTypeDelivery">
                                  {{ orderObj.addressType }}
                                </p>
                              </div>
                              <div class="col-md-12 col-lg-12 col-xl-12">
                                <p class="addressDelivery">
                                  {{ orderObj.address }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="paymentTypeFromData deliveryPaymentType"
                          style="margin-bottom: 12px"
                        >
                          <div class="row">
                            <div class="col-4">
                              <img
                                src="../../templateAssests/img/ckgallery/Delivery.png"
                                alt="thumb"
                                width="70"
                                height="70"
                              />
                            </div>
                            <div class="col-8 align-right">
                              <p>Delivery</p>
                              <p style="margin-bottom: 0px">
                                Estimated Delivery,
                              </p>
                              <p>{{ pickUpon }}</p>
                            </div>
                          </div>
                        </div>

                        <!-- Payment type div -->
                        <div class="paymentTypeFromData">
                          <div class="row">
                            <div class="col-4">Payment Type</div>
                            <div
                              class="col-8 align-right"
                              style="font-family: 'GothamMedium' !important"
                            >
                              {{ PaymentType }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- / Order type Delivery -->
                    </div>
                    <div class="col-md-6 review_content align-right">
                      <div
                        class="clearfix"
                        v-if="orderQrImage == null || orderQrImage == ''"
                      >
                        <span class="orderNo"
                          >Order #<strong>{{ orderInfo }}</strong></span
                        >
                        <p class="orderplacedOn">
                          Placed on: {{ orderPlacedOn }}
                        </p>
                      </div>
                      <div class="clearfix row" v-else>
                        <div class="col-9" style="padding-right: 0px">
                          <span class="orderNo"
                            >Order #<strong>{{ orderInfo }}</strong></span
                          >
                          <p class="orderplacedOn">
                            Placed on: {{ orderPlacedOn }}
                          </p>
                        </div>
                        <div class="col-3" style="margin-bottom: 9px">
                          <img
                            v-if="orderQrImage != null || orderQrImage != ''"
                            :src="
                              orderQrImage == null || orderQrImage == ''
                                ? 'img'
                                : orderQrImage
                            "
                            width="80"
                            height="80"
                            style="object-fit: contain"
                            alt="thumb"
                            class="lazy"
                          />
                        </div>
                      </div>
                      <div
                        class="cartItemsOrderDetails align-left"
                        v-if="cartDetails.length > 0"
                      >
                        <h4 style="font-family: 'GothamMedium' !important">
                          Items <small>({{ cartDetails[0].itemCount }})</small>
                        </h4>
                        <div
                          class="row cartTotalItemDetails"
                          v-for="(items,index) in orderedItemDetails"
                         :key="index"
                          style="margin-top: 2px; margin-bottom: 7px"
                        >
                          <div class="col-8 dishName">
                            <h5>
                              <span>{{ items.quantity }}x </span
                              >{{ items.dishTitle }}
                              <div
                                class="foodTypeContent align-center"
                                :style="{ background: foodType.background }"
                                v-for="foodType in items.foodType"
                                v-bind:key="foodType.name"
                                :id="foodType.name"
                                v-b-tooltip.hover="foodType.name"
                                :title="foodType.name"
                              ></div>
                            </h5>
                            <div
                              class="orderedAddons"
                              v-if="
                                items.orderedItemAddon.length != '' &&
                                items.orderedItemAddon.length != null
                              "
                            >
                              <p
                                v-for="addOns in items.orderedItemAddon"
                                v-bind:key="addOns"
                              >
                                + {{ addOns.addonTitle }}
                              </p>
                            </div>
                            <!-- <div class="dishServings">Serve {{items.servings}}</div>
                                    <div class="foodType align-center" :style="{background : foodType.background}" v-for="foodType in items.foodType" v-bind:key="foodType.name">
                                        {{foodType.shortCode}}
                                      </div> -->
                          </div>
                          <!-- / col -->
                          <div class="col-4 dishDetails align-right">
                            <div class="dishRate align-right">
                              ₹{{ items.itemPrice }}
                            </div>
                            <div
                              class="orderedAddons dishRate align-right"
                              v-if="
                                items.orderedItemAddon.length != '' &&
                                items.orderedItemAddon.length != null
                              "
                            >
                              <p
                                v-for="addOns in items.orderedItemAddon"
                                v-bind:key="addOns"
                              >
                                ₹{{ addOns.addonPrice }}
                              </p>
                            </div>
                          </div>
                          <!-- / col -->
                          <!-- <hr class="hrBorder"> -->
                        </div>
                        <hr class="hrBorder" />
                        <div class="row chargesDiv" style="margin-top: 12px">
                          <div
                            class="col-8"
                            v-if="cartDetails[0].totalCorporateSubsidy > 0"
                          >
                            Corporate Subsidy
                          </div>
                          <!-- / col -->
                          <div
                            class="col-4 align-right"
                            v-if="cartDetails[0].totalCorporateSubsidy > 0"
                          >
                            - ₹{{ cartDetails[0].totalCorporateSubsidy }}
                          </div>
                          <!-- / col -->

                          <div class="col-8">Item Total</div>
                          <!-- / col -->
                          <div class="col-4 align-right">
                            ₹{{ cartDetails[0].itemTotal }}
                          </div>
                          <!-- / col -->

                          <div
                            class="col-8"
                            style="color: #a4827d"
                            v-if="
                              cartDetails[0].couponCode != '' &&
                              cartDetails[0].couponCode != null &&
                              cartDetails[0].couponDiscount > 0
                            "
                          >
                            Discount ({{ cartDetails[0].couponCode }})
                          </div>
                          <!-- / col -->
                          <div
                            style="color: #a4827d"
                            class="col-4 align-right"
                            v-if="
                              cartDetails[0].couponCode != '' &&
                              cartDetails[0].couponCode != null &&
                              cartDetails[0].couponDiscount > 0
                            "
                          >
                            - ₹{{ cartDetails[0].couponDiscount }}
                          </div>
                          <!-- / col -->

                          <div
                            class="col-8"
                            style="color: #a4827d"
                            v-if="
                              cartDetails[0].voucherIdentifier != '' &&
                              cartDetails[0].voucherIdentifier != null &&
                              cartDetails[0].voucherType == 2 &&
                              cartDetails[0].voucherDiscount > 0
                            "
                          >
                            Voucher Redeemption (#{{
                              cartDetails[0].voucherIdentifier
                            }})
                          </div>
                          <!-- / col -->
                          <div
                            style="color: #a4827d"
                            class="col-4 align-right"
                            v-if="
                              cartDetails[0].voucherIdentifier != '' &&
                              cartDetails[0].voucherIdentifier != null &&
                              cartDetails[0].voucherType == 2 &&
                              cartDetails[0].voucherDiscount > 0
                            "
                          >
                            - ₹{{ cartDetails[0].voucherDiscount }}
                          </div>
                          <!-- / col -->

                          <div class="col-8">Taxes & Charges *</div>
                          <!-- / col -->
                          <div class="col-4 align-right">
                            ₹{{ cartDetails[0].tax }}
                          </div>
                          <!-- / col -->

                          <div
                            class="col-8"
                            style="color: #a4827d"
                            v-if="
                              cartDetails[0].voucherIdentifier != '' &&
                              cartDetails[0].voucherIdentifier != null &&
                              cartDetails[0].voucherType == 1 &&
                              cartDetails[0].voucherDiscount > 0
                            "
                          >
                            Voucher Redeemption (#{{
                              cartDetails[0].voucherIdentifier
                            }})
                          </div>
                          <!-- / col -->
                          <div
                            style="color: #a4827d"
                            class="col-4 align-right"
                            v-if="
                              cartDetails[0].voucherIdentifier != '' &&
                              cartDetails[0].voucherIdentifier != null &&
                              cartDetails[0].voucherType == 1 &&
                              cartDetails[0].voucherDiscount > 0
                            "
                          >
                            - ₹{{ cartDetails[0].voucherDiscount }}
                          </div>
                          <!-- / col -->

                          <div
                            class="col-8"
                            v-if="
                              cartDetails[0].walletDiscount != '' &&
                              cartDetails[0].walletDiscount != null &&
                              cartDetails[0].walletDiscount > 0
                            "
                          >
                            Wallet Redeemption ({{
                              cartDetails[0].walletDiscount
                            }}
                            Pts)
                          </div>
                          <!-- / col -->
                          <div
                            class="col-4 align-right"
                            v-if="
                              cartDetails[0].walletDiscount != '' &&
                              cartDetails[0].walletDiscount != null &&
                              cartDetails[0].walletDiscount > 0
                            "
                          >
                            - ₹{{ cartDetails[0].walletDiscount }}
                          </div>
                          <!-- / col -->

                          <hr class="hrBorder" />
                        </div>
                        <div
                          class="row totalchargesDiv"
                          style="margin-top: 12px"
                        >
                          <div class="col-8">Total</div>
                          <!-- / col -->
                          <div class="col-4 align-right">
                            ₹{{ cartDetails[0].orderTotal }}
                          </div>
                          <!-- / col -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /row -->
                </div>
                <!-- /review_card -->
              </div>
              <!-- /reviews -->
              <div class="row cardEndDiv">
                <div class="col-6" v-if="orderStatus == 'Delivered'">
                  <div v-if="generatingInvoice" class="text-center text-danger float-end m-1">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                  <div v-if="invoice_available==0">
                    <button :disabled="generatingInvoice" class="btn_1 view_details"
                            style="
                        color: #000 !important;
                        background: #ffc60c !important;
                      " @click="generateInvoice">
                      <i
                        class="uil-invoice"></i>Generate Invoice
                    </button>
                  </div>

                  <a v-if="invoice_available==1"
                    target="_blank"
                    :href="$ApiUrl + '/restaurant/invoice/'+this.invoice_id+'/' + this.orderObj.oid"
                    >
                    <button
                      class="btn_1 view_details"
                      style="
                        color: #000 !important;
                        background: #ffc60c !important;
                      "
                    > <i class="uil-invoice"></i>
                   Download Invoice
                    </button>
                  </a>
                  <!-- <a href="#">Cancel Order</a> -->
                </div>
                <div class="col-6 align-right">
                  <a href="/"
                    ><button
                      class="btn_1 view_details"
                      style="
                        color: #000 !important;
                        background: #ffc60c !important;
                      "
                    >
                      Home
                    </button></a
                  >
                </div>
              </div>
            </div>
            <!-- /col -->
            <div
              class="col-lg-4 orderStatusCol" id="sidebar_fixed"
            >
              <div class="orderStatusSection" v-if="pageType != 'viewDetails' && orderObj.orderStatus==2" style="padding-bottom: 10px;">
                <img
                  src="../../templateAssests/img/ckgallery/orderplacedDiv.png"
                  width="360"
                />
                <div class="orderStatusDiv">
                  <img
                    src="../../templateAssests/img/ckgallery/tick.png"
                    style="margin-right: 25px"
                  />
                  Order Placed Successfully
                </div>
              </div>

              <div v-if="isOrderRated===1">
              <div
                class="reviews moblieReview"
                v-for="allReviews in allReviewsData"
                :key="allReviews.FeedbackId"
              >
                <section class="ordersSection">
                  <div class="row">
                    <div class="menu_item">
                      <div class="row">
                        <p class="reviewUserName">{{ allReviews.userName }}</p>
                        <p class="reviewDate">{{ allReviews.date }}</p>
                        <div class="col-12" v-if="allReviews.rating > 0">
                          <span v-for="index in 5" :key="index">
                            <i
                              v-if="index <= allReviews.rating"
                              class="fa fa-star"
                              style="margin-right: 5px; color: #ffc60c"
                            ></i>
                            <i
                              v-else
                              class="fa fa-star"
                              style="margin-right: 5px; color: #dadada"
                            ></i>
                          </span>
                        </div>
                        <p class="reviewStarRating">
                          {{ allReviews.rating }} of 5
                        </p>
                      </div>
                      <div class="row">
                        <p class="reviewUserText">{{ allReviews.review }}</p>
                      </div>
                      <div v-if="allReviews.allReplies != ''">
                        <hr style="margin-top: 10px; margin-bottom: 10px" />
                        <div
                          class="reviewReplyBox"
                          v-for="allReplies in allReviews.allReplies"
                          :key="allReplies.FeedbackId"
                        >
                          <div class="row">
                            <div class="col-6 text-left">
                              <p class="reviewReplyFrom">Reply from,</p>
                              <p
                                class="reviewRestName"
                                v-if="allReviews.restName != null"
                              >
                                {{ allReviews.restName }} -
                                {{ allReviews.branchName }}
                              </p>
                            </div>
                            <div class="col-6 text-right">
                              <p class="reviewReplyDate">
                                {{ allReplies.repliedDate }}
                              </p>
                            </div>
                          </div>
                          <p class="reviewRestText">
                            {{ allReplies.replyText }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              </div>
              <div v-else>
                <div v-if="orderObj.orderStatus==7">
                <div v-if="isOrderRated==2 || isOrderRated==0">
                  <feedBackPopup :feedBackData="feedBackData"/>
                </div>
                <div v-if="isProcessing==1" class="d-flex align-items-center text-danger">
                  <b-spinner class="ml-auto"></b-spinner>
                </div>
                <button :disabled="isProcessing==1" class="btn_1 view_details"
                        style="
                        color: #000 !important;
                        background: #ffc60c !important;"
                        @click="rateOrder(orderObj.oid,userDetail)">
                  <i
                      class="uil-star"></i> Rate This Order
                </button>
                </div>
              </div>
            </div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>
      <!-- /bg_gray -->

      <!-- /container -->
    </main>
    <!-- /main -->

    <!-- Modal item order -->
    <b-modal
      id="modal-addAddress"
      modal-class="addDeliveryModal"
      :footer-bg-variant="footerBgVariant"
      hide-header
      size="md"
      centered
    >
      <div class="container deliveryAddContainer">
        <div class="clearfix addDeliveryHeader">
          <h4>Add Delivery Address</h4>
        </div>
        <!-- / clearfix -->

        <div class="deliveryLocat">
          <label>Enter your delivery location*</label>
          <select class="form-select">
            <option value="All">
              Bandra Kurla Complex, G4-A, Ground Floor,Trade Center,
              Bandra(west)
            </option>
            <option value="Veg">Veg</option>
            <option value="Non Veg">Non Veg</option>
          </select>
        </div>
        <!-- / deliveryLocat -->

        <div class="completeAdd InfoText">
          <label>Complete Address*</label>
          <input
            class="form-control"
            type="text"
            placeholder="Flat No, Building, Company, Area."
          />
        </div>
        <!-- / completeAdd -->

        <div class="landmark InfoText">
          <label>Landmark (Optional)</label>
          <input
            class="form-control"
            type="text"
            placeholder="e.g. near Apollo Hospital"
          />
        </div>
        <!-- / completeAdd -->

        <div class="addTypeRadio InfoText">
          <label>Address Type*</label>
          <div class="row">
            <div class="col-3">
              <label class="container_radio"
                >Home
                <input type="radio" value="option1" name="opt_order" checked />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="col-3">
              <label class="container_radio"
                >Work
                <input type="radio" value="option1" name="opt_order" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="col-3">
              <label class="container_radio"
                >Other
                <input type="radio" value="option1" name="opt_order" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <!-- / addTypeRadio -->
      </div>
      <!-- /Container -->
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            class="float-right btnSave btn btn-warning"
            @click="show = false"
          >
            Save
          </b-button>
          <!-- / footer Btn end -->
        </div>
      </template>
    </b-modal>
    <!-- /Modal item order -->

    <footerLayout />
    <!-- footer layout -->
  </div>
  <!-- /root div -->
</template>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <!-- SPECIFIC CSS -->
<script>
import Vue from "vue";
import headerLayout from "../../layouts/headerLayout";
import footerLayout from "../../layouts/footerLayout";
import ClassOnScroll from "vue-class-on-scroll";
import { DropdownPlugin } from 'bootstrap-vue'
Vue.use(DropdownPlugin)
import { TooltipPlugin } from 'bootstrap-vue'
Vue.use(TooltipPlugin)
import "vue-simple-accordion/dist/vue-simple-accordion.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import AxiosPlugin from "vue-axios-cors";
Vue.use(AxiosPlugin);
import feedBackPopup from "../popUpModals/userFeedbackPopup.vue";
export default {
  data() {
    return {
      userDataForFeedback:0,
      feedBackData:[],
      orderQrImage: "",
      orderTypeByEnum: "", //1=> pickup, 2=> delivery
      orderStatus: "",
      orderPlacedOn: "",
      PaymentType: "",
      orderedItemDetails: undefined,
      cartDetails: undefined,
      pickUpon: "",
      isCafeteria: 1,
      autoClose: "",
      picked: "",
      orderObj: "",
      restaurantDetails: "",
      allReviewsData: [],
      terms: false,
      nextStep: true,
      isHidden: true,
      activeTab: "option0",
      deliver: false,
      show: false,
      generatingInvoice:false,
      orderCancel:false,
      isProcessing:0,
      invoice_available:0,
      invoice_id:0,
      isOrderRated:0,
      variants: [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "light",
        "dark",
        "white",
      ],
      footerBgVariant: "white",
      footerTextVariant: "dark",
      userName: "",
      orderInfo: null,
      pageType: "",
      userDetail:"",
    };
  },
  directives: {
    "class-on-scroll": ClassOnScroll,
  },
  computed: {
    isDisabled: function () {
      return !this.terms;
    },
  },
  mounted() {
    this.axios
        .get("/getUserDeatils")
        .then((response) => {
          // console.log(response);
          let status = response.status;
          if (status == 200 && response.data.status == 200) {
            this.userDetail=response.data.userData;
            if (response.data.userData.userName) {
              this.userName = response.data.userData.userName;
              this.userDataForFeedback = response.data.userData.userDataForFeedback;
            } else {
              this.userName = "";
            }
          }
        })
        .catch((error) => {
          if(error.response.status==500){
            this.$swal({
              icon:"error",
              title:"Opps!",
              text:"Something went wrong."
            });
          }
          else{
            this.$swal({
              icon:'error',
              text:error.response.data.message
            });
          }

        });

    if (this.$route.params.pageType) {
      this.pageType = this.$route.params.pageType;
    }
    // var orderDetailsbyID = this.$route.query.od; // 1=> with orderID, 0=>transactionID
    var uri = this.$route.query.id.split("?");
    var isOrderByID = "";
    var orderDetailsID = "";
    if (uri.length == 2) {
      orderDetailsID = uri[0];
      var isOrderByIDArr = uri[1].split("=");
      if (isOrderByIDArr.length == 2) {
       isOrderByID = isOrderByIDArr[1]; // 1=> with orderID, 2=>transactionID
      }
    }
    if (orderDetailsID != "" && isOrderByID != "") {
      let orderIDData = JSON.stringify({
        orderDetailsID: orderDetailsID,
        isOrderByID: isOrderByID,
      });
      Vue.axios.post("/orderDetails", orderIDData).then((res) => {
        //   console.log(res);
        let status = res.status;
        if (status == 200) {
          this.orderInfo = res.data.data.orderID;
          this.orderQrImage = res.data.data.orderQrImage;
          this.orderObj = res.data.data;
          this.invoice_available=res.data.invoice.is_available;
          if(this.invoice_available==1){
            this.invoice_id=res.data.invoice.invoice_id
          }
          if(res.data.data.orderStatus==7)
          {
            this.isOrderRated = res.data.data.isOrderRated;
          }
          let getOrderStatus = res.data.data.orderStatus;
          switch (getOrderStatus) {
            case 1:
              this.orderStatus = "initialized";
              break;
            case 2:
              this.orderStatus = "Placed";
              break;
            case 3:
              this.orderStatus = "Accepted";
              break;
            case 4:
              this.orderStatus = "Preparing";
              break;
            case 5:
              this.orderStatus = "Prepared";
              break;
            case 6:
              this.orderStatus = "Dispatched";
              break;
            case 7:
              this.orderStatus = "Delivered";

              break;
            case 8:
              this.orderStatus = "Cancelled";
              break;
            default:
              this.orderStatus = "Placed";
          }

          let orderData = res.data.data;
          if (
              orderData.enumOrderMethod == "pickup" ||
              orderData.enumOrderMethod == "dinenow" ||
              orderData.enumOrderMethod == "schedule_pickup" ||
              orderData.enumOrderMethod == "subscription_pickup"
          ) {
            this.orderTypeByEnum = 1; //1=> pickup, 2=> delivery
          } else if (
              orderData.enumOrderMethod == "deliver_now" ||
              orderData.enumOrderMethod == "schedule_delivery" ||
              orderData.enumOrderMethod == "subscription_delivery"
          ) {
            this.orderTypeByEnum = 2; //1=> pickup, 2=> delivery
          }

          if (
              res.data.data.paymentMethodName != "" &&
              res.data.data.PaymentModeName != ""
          ) {
            this.PaymentType =
                res.data.data.PaymentModeName +
                " + " +
                res.data.data.paymentMethodName;
          } else if (
              res.data.data.paymentMethodName == "" &&
              res.data.data.PaymentModeName != ""
          ) {
            this.PaymentType = res.data.data.PaymentModeName;
          } else if (
              res.data.data.paymentMethodName != "" &&
              res.data.data.PaymentModeName == ""
          ) {
            this.PaymentType = res.data.data.paymentMethodName;
          }
          this.orderPlacedOn = res.data.data.placedOn;
          this.pickUpon = res.data.data.pickupDateTime;
          this.restaurantDetails = res.data.restaurantDetails;
          this.orderedItemDetails = res.data.orderedItemsDetails;
          this.cartDetails = res.data.totalOrderDetails;
          if(this.isOrderRated==1)
          {
            this.getReviewByOrderID(orderDetailsID);
          }
        }
      });
    }


  },
  components: {
    headerLayout,
    footerLayout,
    feedBackPopup,
  },
  methods: {
    rateOrder(orderId, user) {

      this.isProcessing = 1;
      let rest_branch_for_review = user.rest_branch_for_review;
      if(this.isOrderRated!=1 && user.rest_branch_for_review==0)
      {
        rest_branch_for_review = this.restaurantDetails.restBranchID;
      }
      let formData = new FormData();
      formData.append("orderID", orderId);
      formData.append("principle_branch_id", user.principle_branch_id);
      formData.append("corporate_branch_id", user.corporate_branch_id);
      formData.append("rest_branch_for_review", rest_branch_for_review);

      this.axios.post('/v2/getFdbackQuestionUser', formData)
          .then((response) => {
            let status = response.status;
            if (status == 200 && response.data.status == 200) {
              this.isProcessing = 0;
              this.feedBackData = response.data;
              this.feedBackData.restaurant.userDataForFeedback = this.userDataForFeedback;
              this.$bvModal.show("modal-userFeedback");
            }
          })
          .catch((error) => {
            this.isProcessing = 0;
            alert(error.response.data.message);
          });
    },
    getReviewByOrderID(orderID) {
      this.axios
          .post("getFdbackReviewByOrderID", {
            orderID: orderID,
          })
          .then((response) => {
            this.averageRating = response.data.Avg;
            this.allReviewsData = response.data.data;
          });
    },
    generateInvoice() {
      this.generatingInvoice = true;
      this.axios
          .post("restaurant/invoice/generate", {orderID: this.orderInfo})
          .then((result) => {
            this.generatingInvoice = false;
            if (result.data.status == 1) {
              this.invoice_id = result.data.invoice_id;
              this.invoice_available = 1;
            }
            alert(result.data.message);
          });
    },
    cancelOrder(id) {
      this.$confirm("Do you want to cancel this order ?", "Are you sure?", "")
          .then(() => {
            this.orderCancel = true;
            let formData = new FormData();
            formData.append("order_id", id);

            this.axios
                .post("cancel-order", formData)
                .then((result) => {
                  this.orderCancel = false;
                  this.$swal({
                    title:"Order Cancellation",
                    text:result.data.message
                  }).then(()=>{
                    location.reload();
                  });
                })
                .catch((error) => {
                  this.orderCancel = false;
                  this.$swal({
                    title:"Order Cancellation",
                    text:error.response.data.message
                  });
                });
          });
    }
  }
};
</script>
<style scoped src="../../templateAssests/css/listing.css"></style>
    <style scoped src="../../templateAssests/css/detail-page.css"></style>
<style scoped>
a.deliverCard {
  max-height: 100px !important;
  padding: 12px 20px 12px 20px !important;
}
a.deliverCard figure {
  float: left !important;
  margin-right: 11px !important;
}
.deliveryCardDiv {
  margin-top: 10px;
}
.deliverH3 {
  margin-bottom: 12px !important;
}
.align-right {
  text-align: right;
}
.align-left {
  text-align: left;
}
.customAnch {
  color: #f3766a !important;
}

.addDeliveryModal > .modal-dialog > .modal-content > .modal-body {
  padding: 30px !important;
}
.review_card {
  padding: 25px 25px 25px 25px;
}

.addressType h5 {
  font-size: 16px;
}
.address span {
  font-size: 14px;
}

.btn_1 {
  background: #a4827d;
}

.btnSave {
  width: 85px;
  height: 35px;
}

.locationDetails p {
  margin-bottom: 0;
  margin-top: 1rem;
  color: #a6a1a1;
}

.dishServings img {
  margin-right: 5px;
}

.dishName h5 {
  font-size: 14px;
  margin-bottom: 2px;
}

.cardTitle {
  font-size: 20px;
}
.orderStatus {
  font-size: 16px;
}
.orderNo {
  color: #777777;
  font-size: 14px;
}
.orderplacedOn {
  color: #777777;
  font-size: 14px;
}
#reviews {
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05) !important;
}

.deliveryAddContainer {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.addDeliveryHeader {
  margin-top: 31px;
  margin-bottom: 27px;
}
.InfoText label {
  color: #777;
  font-size: 14px;
  margin: 0px 0px 10px;
}
.deliveryLocat select,
.completeAdd input,
.landmark input {
  margin-bottom: 21px;
}
.addTypeRadio label {
  margin: 0px 0px 19px;
}

main {
  margin-top: 68px;
}

.hrBorder {
  width: 96%;
  margin-top: 11px;
}
a.restaurantCard figure {
  width: 70px;
  height: 70px;
  overflow: hidden;
  /* position: absolute; */
  margin: 0;
  /* left: 20px;
      top: 12px; */
  border: 1px solid #fff;
  border-radius: 3px;
}
.cartItemsOrderDetails {
  border: 1px solid #f5f5f5;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px 16px 20px 16px;
}
.chargesDiv div {
  margin-top: 5px;
  margin-bottom: 5px;
}
.totalchargesDiv {
  font-size: 17px;
  font-family: "GothamMedium" !important;
}
.paymentTypeFromData {
  padding: 12px 20px 12px 20px;
  border: 1px solid #f5f5f5;
  box-sizing: border-box;
  border-radius: 5px;
}
.deliverToCardDiv {
  padding: 12px 20px 12px 20px;
  border: 1px solid #f5f5f5;
  box-sizing: border-box;
  border-radius: 5px;
}
.orderStatusDiv {
  color: #ffffff;
  font-size: 14px;
  position: absolute;
  top: 15px;
  left: 40px;
}

.addressTypeDelivery {
  font-size: 16px;
  color: #222222;
}
.addressDelivery {
  color: #777;
  font-size: 14px;
}

.cardEndDiv a {
  color: #f3766a;
  font-size: 16px;
}
.orderedAddons p {
  font-size: 12px;
  margin-bottom: 0px;
}
@media (max-width: 971px) {
  /* .orderStatusCol {
      display: none;
    } */
  .paymentTypeFromData {
    margin-bottom: 12px;
  }
}
@media (min-width: 1200px) {
  .deliveryAddContainer {
    max-width: 95% !important;
  }
}
@media only screen and (max-width: 991px) {
  .moblieReview {
    padding: 10px 10px !important;
  }
}
.menu_item {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  display: block;
  position: relative;
  padding: 15px;
}
.reviewUserName {
  font-weight: 600;
  font-size: 14px;
  color: #663333;
  margin-bottom: 8px;
}
.reviewDate {
  font-weight: 300;
  font-size: 13px;
  color: #979797;
  margin-bottom: 8px;
}
.reviewStarRating {
  font-weight: 300;
  font-size: 9px;
  color: #663333;
  margin-top: 2px;
  margin-bottom: 8px;
}
.reviewUserText {
  font-weight: 300;
  font-size: 14px;
  color: #663333;
  margin-bottom: 0px;
  line-height: 17px;
  word-break: break-word;
}
.reviewReplyBox {
  border-left: 5px solid #f3766a;
  padding-left: 10px;
}
.reviewReplyFrom {
  font-weight: 300;
  font-size: 11px;
  color: #979797;
  margin-bottom: 8px;
}
.reviewReplyDate {
  font-weight: 300;
  font-size: 13px;
  color: #979797;
  margin-top: 10px;
  margin-bottom: 8px;
}
.reviewRestName {
  font-weight: 600;
  font-size: 14px;
  color: #663333;
  margin-bottom: 8px;
}
.reviewRestText {
  font-weight: 300;
  font-size: 14px;
  color: #663333;
  margin-bottom: 0px;
  word-break: break-word;
}
</style>